{
  "nl": {
    "marketplace_partner": {
      "contact_me": {
        "button": "Neem contact met mij op!",
        "failure": "Er trad een onverwachte fout op.",
        "success": "Wij nemen binnenkort contact met u op."
      }
    }
  }
}
